module.exports = __webpack_public_path__ + "static/media/illustration.160f59d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustration.svg
// module id = 267
// module chunks = 21